import useStore from '../../../store'
import { useMemo, useState } from 'react'
import { Widget, WidgetBody, WidgetHeader, WidgetFooter } from '../../ui/Widget'
import VCIDealerRow from './VCIDealerRow'
import AmSearchBar from '../../common/AmSearchBar'
import Pagination from '../../common/Pagination'
import dealerFilter from '../../../utilities/dealerFilter'
import sortByFieldAuditDueOn from '../../../utilities/sortByFieldAuditDueOn'

const DEALERS_PER_PAGE = 25

export default function Dealers() {
  const auditDealers = useStore((state) => state.auditDealers)
  const trailerLocations = useStore((state) => state.trailerLocations)
  const dealersFetching = useStore((state) => state.auditDealersFetching)
  const trailerLocationsFetching = useStore((state) => state.trailerLocationsFetching)
  const auditDealersPage = useStore((state) => state.auditDealersPage)
  const setAuditDealersPage = useStore((state) => state.setAuditDealersPage)

  const [searchTerm, setSearchTerm] = useState('')
  const [appliedSearchTerm, setAppliedSearchTerm] = useState('')

  const auditTargets = useMemo(
    () => sortByFieldAuditDueOn([...(auditDealers ?? []), ...(trailerLocations ?? [])]),
    [auditDealers, trailerLocations]
  )

  const filteredDealers = dealerFilter(auditTargets, appliedSearchTerm)
  const totalPages = Math.ceil(filteredDealers.length / DEALERS_PER_PAGE)
  const currentPage = auditDealersPage - 1
  const paginatedDealers = filteredDealers.slice(
    currentPage * DEALERS_PER_PAGE,
    currentPage * DEALERS_PER_PAGE + DEALERS_PER_PAGE
  )

  const handlePageClick = (event) => {
    setAuditDealersPage(event.selected + 1)
  }

  const handleSearch = (value) => {
    setAppliedSearchTerm(value)
    setAuditDealersPage(1)
  }

  const handleResetFilter = () => {
    setSearchTerm('')
    setAppliedSearchTerm('')
    setAuditDealersPage(1)
  }

  return(
    <Widget>
      <WidgetHeader title="Dealer Audits">
        <AmSearchBar
          handleSearch={handleSearch}
          handleReset={handleResetFilter}
          showFilterIcon={false}
          dataFetching={dealersFetching || trailerLocationsFetching}
          searchBarValue={searchTerm}
          setSearchBarValue={setSearchTerm}
        />
      </WidgetHeader>
      <WidgetBody>
        {paginatedDealers.map((dealer) => (
          <VCIDealerRow
            key={dealer.key}
            dealer={dealer}
            searchTerm={appliedSearchTerm}
          />
        ))}
      </WidgetBody>
      <WidgetFooter isSticky>
        <Pagination
          currentPage={currentPage}
          lastPage={totalPages - 1}
          dataTotal={filteredDealers.length}
          handlePageClick={handlePageClick}
          totalPages={totalPages}
          styles='py-4'
        />
      </WidgetFooter>
    </Widget>
  )
}
